/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'Verifications' store object.
 * @namespace VerificationsSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAVerifications';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static postVerificationsCreateCaseworkerTask = state =>
    state[selectors.moduleIdentifier].postVerificationsCreateCaseworkerTask.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static isFetchingPostVerificationsCreateCaseworkerTask = state =>
    state[selectors.moduleIdentifier].isFetchingPostVerificationsCreateCaseworkerTask.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static postVerificationsCreateCaseworkerTaskError = state =>
    state[selectors.moduleIdentifier].postVerificationsCreateCaseworkerTaskError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static postVerificationsLinkFile = state =>
    state[selectors.moduleIdentifier].postVerificationsLinkFile.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static isFetchingPostVerificationsLinkFile = state =>
    state[selectors.moduleIdentifier].isFetchingPostVerificationsLinkFile.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static postVerificationsLinkFileError = state =>
    state[selectors.moduleIdentifier].postVerificationsLinkFileError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static deleteVerificationsFileLinksByLinkId = state =>
    state[selectors.moduleIdentifier].deleteVerificationsFileLinksByLinkId.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static isFetchingDeleteVerificationsFileLinksByLinkId = state =>
    state[selectors.moduleIdentifier].isFetchingDeleteVerificationsFileLinksByLinkId.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static deleteVerificationsFileLinksByLinkIdError = state =>
    state[selectors.moduleIdentifier].deleteVerificationsFileLinksByLinkIdError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static fetchVerifications = state => state[selectors.moduleIdentifier].fetchVerifications.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static isFetchingFetchVerifications = state =>
    state[selectors.moduleIdentifier].isFetchingFetchVerifications.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static fetchVerificationsError = state =>
    state[selectors.moduleIdentifier].fetchVerificationsError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static getVerificationsByVerificationId = state =>
    state[selectors.moduleIdentifier].getVerificationsByVerificationId.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static isFetchingGetVerificationsByVerificationId = state =>
    state[selectors.moduleIdentifier].isFetchingGetVerificationsByVerificationId.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static getVerificationsByVerificationIdError = state =>
    state[selectors.moduleIdentifier].getVerificationsByVerificationIdError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static postVerificationsSdCreateCaseworkerTask = state =>
    state[selectors.moduleIdentifier].postVerificationsSdCreateCaseworkerTask.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static isFetchingPostVerificationsSdCreateCaseworkerTask = state =>
    state[selectors.moduleIdentifier].isFetchingPostVerificationsSdCreateCaseworkerTask.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof VerificationsSelectors
   */
  static postVerificationsSdCreateCaseworkerTaskError = state =>
    state[selectors.moduleIdentifier].postVerificationsSdCreateCaseworkerTaskError.payload;
}
